module.exports = __webpack_public_path__ + "static/media/DebugPos.f7ede42f.png";